const isDevelopment = process.env.NODE_ENV === 'development';

export const config = {
    apiUrl: isDevelopment
        ? 'http://localhost:5001'
        : 'https://chriswhitelam.com',
}; 